import React from 'react';
import { GENERIC_TABLE_EXPORT_MENU_EVENT } from '../../shared/GenericTable';

export const dashboardItemsTableDefaults = {
    hideTopToolbar: true,
    enableGlobalFilter: false,
    enableRowSelection: false,
    loading: false,
} as const;

export const dashboardSummaryTableDefaults = {
    hideTopToolbar: true,
    enableGlobalFilter: false,
    enableRowSelection: false,
    enableColumnFilters: false,
    loading: false,
} as const;

export function openDashboardReportExportMenu(
    event: React.MouseEvent<HTMLButtonElement>,
) {
    window.dispatchEvent(
        new CustomEvent(GENERIC_TABLE_EXPORT_MENU_EVENT, {
            detail: { anchorEl: event.currentTarget },
        }),
    );
}
